export default __webpack_public_path__ + "static/media/about-2.f71d54e1.png";